var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-card-title',{},[_c('span',{staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.vessel.name))]),_c('i',{staticStyle:{"font-size":"12px"}},[_vm._v("Position: "+_vm._s(_vm.vessel.getPositionDisplay()))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }